<template>
    <div style="padding: 0 20px;">
        <div class="head_title" style="margin: 20px 0;">AI Search Demo</div>
        <div style="margin: 0 auto; width: 100%;">
            <a-card title="Minitable Restaurant Assistant" :bodyStyle="{ padding: '10px 5px' }" style="width: 100%; position: relative;" :style="{ height: custom_height + 'px' }">
                <div slot="extra">
                    <a-button @click="do_new_chat">
                        <a-icon type="redo"/>
                        New Chat
                    </a-button>
                </div>
                <div class="chat_container" :style="{ height: custom_height - 120 + 'px' }">
                    <div v-for="item in dialog_list" v-bind:key="item.index">
                        <div style="display: block;">
                            <div :class="{ 'left': item.is_ai == 1, 'right': item.is_ai == 0}">
                                <span v-if="item.type == 'text'">
                                    <span v-if="item.content" v-html="item.content">
                                    </span>
                                    <span v-else>
                                        <p>
                                            <span>{{ status_content || 'Analysis and searching restaurants…' }}</span>
                                            <span style="font-size: 12px; color: #999; margin-left: 10px;">{{ counting + 's' }}</span>
                                        </p>
                                        <div v-if="tip_content" style="margin-top: 10px; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
                                            <span v-html="tip_content"></span>
                                        </div>
                                    </span>
                                </span>
                                <div v-if="item.type == 'cards'">
                                    <div v-for="item in item.list" v-bind:key="item.index">
                                        <a-card :title="item.name" :bordered="true" style="width: 100%; margin-top: 10px;">
                                            <h4>{{ item.address }}</h4>
                                            <h5>{{ item.phone || item.phone_number }}</h5>
                                            <div style="margin-top: 10px;">
                                                <a-button style="display: inline-block; margin-right: 10px;"  @click="do_show_merchant_detail(item)" type="primary" >Details</a-button>
                                                <a-button style="display: inline-block;" @click="do_go_website(item)" type="primary" >Website </a-button>
                                            </div>
                                        </a-card>
                                    </div>
                                </div>
                                <span class="time">{{ item.time }}</span>
                            </div>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </div>
                <div style="position: absolute; bottom: 0px; left: 0px;width: 100%; padding: 10px 5px;">
                    <a-input-search :loading="is_loading" v-model="content" style="width: 100%;" enter-button="Send" placeholder="Type your message" @search="onSearch" />
                </div>
            </a-card>
        </div>
        <a-modal v-model="show_merchant_detail" @ok="do_hide_merchant_detail" :title="merchant_detail.name" width="800px">
            <p>
                <span style="width: 120px; font-weight: bold; display: inline-block;">Address:</span>
                {{  merchant_detail.address || '' }}
            </p>
            <p>
                <span style="width: 120px; font-weight: bold; display: inline-block;">Phone:</span>
                {{  merchant_detail.phone || '' }}
            </p>
            <p>
                <span style="width: 120px; font-weight: bold; display: inline-block;">Opening hours:</span>
                {{  merchant_detail.hours || '' }}
            </p>
            <p>
                <span style="width: 120px; font-weight: bold; display: inline-block;">Website:</span>
                <a target="__blank" :href="merchant_detail.website">{{  merchant_detail.website || '' }}</a>
            </p>
            <p>
                <span style="width: 120px; font-weight: bold; display: inline-block;">Price:</span>
                {{  merchant_detail.price_range || '' }}
            </p>
            <p>
                <span style="width: 120px; font-weight: bold; display: inline-block;">Wait time:</span>
                {{  merchant_detail.estimated_wait_time || '' }}
            </p>
            <p>
                <span style="width: 120px; font-weight: bold; display: inline-block;">Peak hours:</span>
                {{  merchant_detail.peak_hours || '' }}
            </p>
            <p>
                <span style="width: 180px; font-weight: bold; display: inline-block;">Recommended reason:</span>
                {{  merchant_detail.recommendation_reason || '' }}
            </p>
        </a-modal>
    </div>
</template>

<script>
    import Vue from 'vue';

    import VueSweetalert2 from "vue-sweetalert2";
    Vue.use(VueSweetalert2);

    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
    import moment from "moment";
    import StreamingProcessor from '@/kits/aisearch';

    export default {
        name: 'ai_search',
        components: {
        },
        data() {
            return {
                is_loading: false,
                debug: this.$store.state.debug,
                token: this.$store.state.app.token,
                dialog_list: [
                    {
                        index: 0,
                        type: "text",
                        content: "Hello! I'm Minitable, your restaurant recommendation assistant. I can help you find the perfect restaurant. What type of cuisine are you looking for?",
                        time: moment().format('HH:mm'),
                        is_ai: 1
                    },
                    // {
                    //     index: 1,
                    //     type: "text",
                    //     content: '',
                    //     time: moment().format('HH:mm'),
                    //     is_ai: 1
                    // }
                ],
                session_id: '',
                content: '',
                show_merchant_detail: false,
                merchant_detail: {},
                now_index: -1,
                is_receiving: false,
                custom_height: window.innerHeight - 100,
                counting: 0,
                countingTimer: null,

                buffer: '',
                currentMessage: null,
                currentData: '',

                function_tip_mapper: {
                    agentFlowEvent: 'Analysis IN PROGRESS',
                    agentFlowExecutedData: 'Analysis COMPLETED',
                    calledTools: 'Fetching data...',
                },
                status_content: '',
                tip_content: '',
                last_agent_event: '',

                streamingProcessor: new StreamingProcessor({
                    update_status_content: this.update_status_content,
                    update_tip_content: this.update_tip_content
                }),
            };
        },
        async created() {
        },
        watch: {
        },
        mounted() {
            // this.init_eventsource();
            // this.test_search();
        },
        computed: {
            ...mapGetters({
            }),
            ...mapState({
            })
        },
        methods: {
            ...mapActions({
                // doAiSearch: 'experiment/doAiSearch',
            }),
            ...mapMutations({
                set_msg: 'app/APP_SET_MSG'
            }),
            do_new_chat() {
                this.session_id = '';
                this.dialog_list = [
                    {
                        index: 0,
                        type: "text",
                        content: "Hello! I'm MiniPass, your restaurant recommendation assistant. I can help you find the perfect restaurant. What type of cuisine are you looking for?",
                        time: "13:42",
                        is_ai: 1
                    }
                ];
                this.content = '';
            },
            do_show_merchant_detail(item) {
                this.show_merchant_detail = true;
                this.merchant_detail = item;
            },
            do_hide_merchant_detail() {
                this.show_merchant_detail = false;
                this.merchant_detail = {};
            },
            async onSearch() {
                this.do_ai_search();
            },
            async do_ai_search() {
                if (!this.content) {
                    this.$message.error('Please input content.')
                    return;
                }

                if (this.is_loading) {
                    return;
                }

                this.dialog_list.push({
                    index: this.dialog_list.length,
                    type: "text",
                    content: this.content,
                    time: moment().format('HH:mm'),
                    is_ai: 0
                });

                setTimeout(() => {
                    let objDiv = document.getElementsByClassName('chat_container')[0];
                    objDiv.scrollTop = objDiv.scrollHeight;
                }, 100);

                this.is_loading = true;
                this.now_index = this.dialog_list.length;

                this.dialog_list.push({
                    index: this.now_index,
                    type: "text",
                    content: '',
                    time: moment().format('HH:mm'),
                    is_ai: 1
                });

                this.countingTimer = setInterval(() => {
                    this.counting++;
                }, 1000);

                let question = this.content;
                this.content = '';

                let post_data = { question: question, streaming: true };

                if (this.session_id) {
                    post_data.overrideConfig = {};
                    post_data.overrideConfig.sessionId = this.session_id;
                }

                const response = await fetch('https://agents.minitable.net/api/v1/prediction/ab8a8524-afab-4eab-b51c-b48042285753', {
                    method: 'POST',
                    headers: {
                        Authorization: "Bearer ZNIknxK9bBa-G6LIwir5RQ0JxQAShXXAvkJmlVGXb5w",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(post_data)
                });

                if (!response.body) {
                    this.$message.error('不支持流式响应');
                    return;
                }

                const reader = response.body.getReader();
                const decoder = new TextDecoder('utf-8');
                let done = false;

                while (!done) {
                    const { value, done: readerDone } = await reader.read();
                    if (value) {
                        const chunk = decoder.decode(value, { stream: true });
                        // console.log(chunk);

                        this.parse_stream_data(chunk);
                    }
                    done = readerDone;
                }

                this.parse_stream_data('');

                setTimeout(() => {
                    let objDiv = document.getElementsByClassName('chat_container')[0];
                    objDiv.scrollTop = objDiv.scrollHeight;
                }, 100);

                this.is_loading = false;
                clearInterval(this.countingTimer);
                this.counting = 0;

                if (done) {
                    this.do_parse_json();
                }
            },
            update_status_content(content) {
                this.status_content = content;
            },
            update_tip_content(content) {
                this.tip_content = content;
            },
            parse_stream_data(chunk) {
                // 支持一次性解析多条 message/data
                const lines = chunk.split('\n');
                let currentMessage = null;
                let currentData = '';
                let isCollectingData = false;

                for (let i = 0; i < lines.length; i++) {
                    const line = lines[i].trim();
                    if (line === '') continue;

                    if (line.startsWith('message')) {
                        // 如果有上一条未处理的data，先处理
                        if (currentMessage && currentData) {
                            try {
                                const json = JSON.parse(currentData);
                                this.pares_event_data(json);
                            } catch (e) {
                                // console.error('JSON 解析失败:', currentData);
                            }
                        }
                        currentMessage = line;
                        currentData = '';
                        isCollectingData = false;
                    } else if (line.startsWith('data:')) {
                        currentData = line.slice('data:'.length).trim();
                        isCollectingData = true;
                    } else if (isCollectingData) {
                        // data内容被拆成多行，继续拼接
                        currentData += '\n' + line;
                    }
                }

                // 处理最后一条未处理的data
                if (currentMessage && currentData) {
                    try {
                        const json = JSON.parse(currentData);
                        this.pares_event_data(json);
                    } catch (e) {
                        // console.error('JSON 解析失败:', currentData);
                    }
                }
            },
            pares_event_data(json) {
                this.streamingProcessor.processEvent(json);

                if (json.event === 'token') {
                    this.dialog_list[this.now_index].content += json.data;
                } else if (json.event === 'metadata') {
                    if (json.data.sessionId && !this.session_id) {
                        this.session_id = json.data.sessionId;
                    }
                } else {
                    if (this.last_agent_event !== json.event) {
                        // if (json.event === 'agentFlowExecutedData' && this.last_agent_event === 'calledTools') {
                        //     this.status_content = 'Parsing data...';
                        // } else {
                        //     this.status_content = this.function_tip_mapper[json.event];
                        // }
                        
                        this.last_agent_event = json.event;
                    }
                }
            },
            init_eventsource() {
                let aj_host = this.debug ? 'http://127.0.0.1:5050' : '';
                var source = new EventSource(aj_host + '/events');
                let that = this;

                source.onmessage = function(event) {
                    // console.log(event.data);
                    if (that.now_index > -1) {
                        that.is_receiving = true;

                        let ori_text = that.dialog_list[that.now_index].content;
                        let new_text = ori_text + event.data;

                        if (new_text.indexOf('minitable_done') > -1 ){
                            new_text = new_text.replace('minitable_done', '');
                            that.is_receiving = false;
                            that.dialog_list[that.now_index].content = new_text;
                            that.do_parse_json();
                        } else {
                            that.dialog_list[that.now_index].content = new_text;
                        }
                    }
                };

                source.onopen = function(event) {
                    console.log('Connection was opened.');
                };

                source.onerror = function(event) {
                    console.error('Error occurred:', event);
                };
            },
            do_parse_json() {
                setTimeout(() => {
                    let now_content = this.dialog_list[this.now_index].content;
                    
                    if (now_content.indexOf('recommendedRestaurants') > -1 || now_content.indexOf('recommended_restaurants') > -1) {
                        now_content = now_content.replace('```json', '');
                        now_content = now_content.split('```')[0];
                        now_content = now_content.replace('```', '');
                        now_content = now_content.replace('minitable_done', '');
                        now_content = now_content.trim();
                        now_content = now_content.replace(/\\n/g, '');

                        // console.log(now_content);

                        // now_content = now_content.match(/\{.+\}/)[0];

                        let data = JSON.parse(now_content);
                        let cards = data.recommendedRestaurants || data.recommended_restaurants;

                        this.dialog_list[this.now_index].type = 'cards';
                        this.dialog_list[this.now_index].list = cards;
                    } else {
                        now_content = now_content.replace(/\\n/g, '<br>');
                        now_content = now_content.replace(/\n/g, '<br>');
                        this.dialog_list[this.now_index].content = now_content;
                    }

                    this.now_index = -1;
                }, 100);
            },
            do_go_website(item) {
                window.open(item.website, '_blank');
            }
        },
    };
</script>

<style scoped>
    body {
        height: 100vh !important;
        overflow: hidden !important;
    }

    .chat_container {
        height: 80%;
        overflow: auto;
        background-color: #f9fafb;
        padding: 10px 20px 10px 10px;
    }

    .chat_container .left {
        width: 80%;
        height: auto;
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        margin-top: 10px;
    }

    .chat_container .right {
        width: 50%;
        height: auto;
        background-color: #3c82f6;
        padding: 10px;
        border-radius: 10px;
        color: #fff;
        float: right;
        margin-top: 10px;
    }

    .chat_container .time {
        display: block;
        margin-top: 5px;
        opacity: 0.7;
    }
</style>
